import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { loaders, recruitmentStatusConfig } from 'entities';

import {
  CircleXIcon,
  ClockIcon,
  DoubleCheckIcon,
  FolderIcon,
  UserMinusIcon,
  UserSpeakIcon,
} from 'components/Icons';

import CardGrid from './CardGrid';

import { useRecruitmentHome } from './context';

const iconMapping: Record<string, ReactNode> = {
  [recruitmentStatusConfig.unassigned.code]: <UserMinusIcon size={22} color="#fc8a05" />,

  [recruitmentStatusConfig.notStarted.code]: <ClockIcon size={22} color="#636973" />,

  [recruitmentStatusConfig.active.code]: <UserSpeakIcon size={22} color="#014272" />,

  [recruitmentStatusConfig.done.code]: <DoubleCheckIcon size={22} color="#19c29b" />,

  [recruitmentStatusConfig.denied.code]: <CircleXIcon size={22} color="#e47474" />,
};

const zeroCountOrderResolution = [
  recruitmentStatusConfig.active.code,
  recruitmentStatusConfig.unassigned.code,
  recruitmentStatusConfig.notStarted.code,
  recruitmentStatusConfig.done.code,
  recruitmentStatusConfig.denied.code,
];

export function RecruitmentStatuses() {
  const { t } = useLang();

  const { state, changeStatus } = useRecruitmentHome();

  const { data, errorOrLoading } = loaders.projects.getRecruitmentCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'RECRUITMENT_CONTROL_COUNTS',

      onMessage: ({ counts }) => counts,
    },

    onDataChange: (counts) => {
      if (counts[state.status]) return;

      const withRecruitments = zeroCountOrderResolution.find((status) => counts[status]);

      if (withRecruitments) changeStatus(withRecruitments);
    },
  });

  return (
    <CardGrid
      title={t('recruitments')}
      icon={<FolderIcon color="#fff" />}
      loading={errorOrLoading}
      items={Object.values(recruitmentStatusConfig).map(({ getLabel, code }) => ({
        getLabel,
        status: code,
        count: data[code] ?? 0,
        icon: iconMapping[code],
      }))}
    />
  );
}
